module.exports = __webpack_public_path__ + "img/PhoneIcon.9b304dcd.svg";